export const Logo = ({ className = '', size = 'md', variant = 'color' }) => {
  const filterStyle = {
    color: 'none',
    white: 'brightness(0) invert(1)',
    dark: 'drop-shadow(0 0 8px rgba(255,255,255,0.9))',
  }[variant] || 'none';

  const logoUrl = "https://customer-assets.emergentagent.com/job_5da696ca-0b63-4030-a56d-91cfe9c3a2ac/artifacts/pztyy1sv_PHOTO-2026-02-23-18-13-22-removebg-preview.png";

  // Navbar — kompakt kırpılmış logo (68×42px görüntü alanı)
  if (size === 'sm') {
    return (
      <div
        className={`flex-shrink-0 self-center ${className}`}
        style={{
          width: '52px',
          height: '32px',
          backgroundImage: `url("${logoUrl}")`,
          backgroundSize: '100px auto',
          backgroundPosition: '-25px -11px',
          backgroundRepeat: 'no-repeat',
          filter: filterStyle,
        }}
        data-testid="logo-img"
      />
    );
  }

  // Hero / büyük kullanım — aynı kırpma ama 4× büyük (272×168px)
  if (size === 'lg') {
    return (
      <div
        className={`${className}`}
        style={{
          width: '272px',
          height: '168px',
          backgroundImage: `url("${logoUrl}")`,
          backgroundSize: '520px auto',
          backgroundPosition: '-132px -56px',
          backgroundRepeat: 'no-repeat',
          filter: filterStyle,
        }}
        data-testid="logo-img"
      />
    );
  }

  // Orta boyut — standart
  return (
    <img
      src={logoUrl}
      alt="Ultra Sport – Sports Event Goodies"
      className={`h-12 w-auto object-contain ${className}`}
      style={{ filter: filterStyle }}
      data-testid="logo-img"
    />
  );
};
